import type { Kalla, Teoripost, TeoriKategori, TeoriTyp } from '../types'
import teorisektionJson from '../content/teorisektion.json'

// Teorisektionen är liten (37 korta poster) och ligger därför synkront i
// huvudbundeln, precis som begreppsdatabasen — uppslags-, post- och
// jämförelsesidorna behöver ingen förladdning.
const data = teorisektionJson as { poster: Teoripost[]; kallor: Kalla[] }

/** Alla poster, A–Ö (sorterade av synken med svensk ordning). */
export const allaTeoriposter: Teoripost[] = data.poster

/** Samlade källförteckningen — källorna posterna vilar på. */
export const allaKallor: Kalla[] = data.kallor

const perId = new Map(allaTeoriposter.map((p) => [p.teori_id, p]))
const kallaPerId = new Map(allaKallor.map((k) => [k.kalla_id, k]))

export const hittaTeoripost = (id: string): Teoripost | null => perId.get(id) ?? null

export const kallorFor = (post: Teoripost): Kalla[] =>
  post.kalla_id.map((id) => kallaPerId.get(id)).filter((k): k is Kalla => Boolean(k))

export const KATEGORI_ETIKETT: Record<TeoriKategori, string> = {
  motivation: 'Motivation',
  grupp: 'Grupper',
  kommunikation: 'Kommunikation',
  konflikt: 'Konflikter',
  ledarskap: 'Ledarskap',
  organisation: 'Organisation',
  kultur: 'Organisationskultur',
  'etik-och-hallbarhet': 'Etik & hållbarhet',
  analys: 'Analys',
}

export const TYP_ETIKETT: Record<TeoriTyp, string> = {
  teori: 'Teori',
  modell: 'Modell',
  metod: 'Metod',
}

/** Styrdokumentets konvention: tomt källkritik-fält är inget friskintyg och
 *  får aldrig bli tom yta i jämförelsen — standardtexten används i stället. */
export const KALLKRITIK_SAKNAS =
  'Läromedlet anger inget särskilt förbehåll för den här modellen.'
